<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form">
        <template slot="tableSearch">
          <el-form-item label="登录名称">
            <el-input
              v-model="form.loginName"
              placeholder="登录名称"
            ></el-input>
          </el-form-item>
        </template>

        <!-- <template slot="buttonArea">
                    <el-button type="primary" @click="add" size="small">添加用户</el-button>
                </template> -->

        <template slot="tableColumn">
          <el-table-column align="center" prop="loginName" label="登录名称">
          </el-table-column>
          <el-table-column prop="name" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="roleName" label="所属角色" align="center">
          </el-table-column>
          <el-table-column
            prop="isLocked"
            label="是否锁定"
            :formatter="$formatter.formatBoolean"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="创建时间"
            :formatter="$formatter.formatDate"
            width="200px"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="createdBy" label="创建人" align="center">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="220"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="deleteUser(scope.row)"
                >删除用户</el-button
              >
              <el-button type="text" size="small" @click="deleteRole(scope.row)"
                >删除此角色</el-button
              >
              <el-button type="text" size="small" @click="addRole(scope.row)"
                >增加角色</el-button
              >
            </template>
          </el-table-column>
        </template>
      </page>

      <user-edit
        :show.sync="showDialog"
        :formData="formData"
        :action="action"
      ></user-edit>
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import UserEdit from "@/components/auth/UserEdit.vue";
import Upload from "@/components/Upload.vue";
export default {
  name: "Users",
  components: {
    "user-edit": UserEdit,
    page: Page,
    upload: Upload,
  },

  data() {
    return {
      form: {
        loginName: "",
        systemId: "",
      },
      formData: null,
      action: null,
      url: "/sysUserInfo/selectUserList",
      showDialog: false,
      systemList: [],
    };
  },

  methods: {
    deleteUser(row) {
      this.$confirm(
        "确认要删除用户【" + row.name + "】吗？此操作会删除所有角色。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.axios
            .post("/sysUserInfo/deleteUser", { id: row.id })
            .then((res) => {
              if (res.code === 200) {
                this.$bus.$emit("refresh"); //通知刷新
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "success",
                });
              } else {
                this.$notify.error({
                  title: "提示",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },

    deleteRole(row) {
      this.$confirm(
        "确认要删除用户【" + row.name + "】的角色【" + row.roleName + "】吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.axios
            .post("/sysUserInfo/deleteRole", { id: row.id, roleId: row.roleId })
            .then((res) => {
              if (res.code === 200) {
                this.$bus.$emit("refresh"); //通知刷新
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "success",
                });
              } else {
                this.$notify.error({
                  title: "提示",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },

    addRole(row) {
      this.action = "addRole";
      this.formData = row;
      this.showDialog = true;
    },

    add() {
      this.action = "addUser";
      this.formData = null;
      this.showDialog = true;
    },
  },
  created() {},
};
</script>

<style scoped>
</style>